<template>
  <div class="popover-container">
    <a href="javascript:void(0)" class="ls-ico-help" @mouseover.prevent="showPopover" @mouseout.prevent="hidePopover"></a>
    <div class="ls-popover" :class="className">
      <div class="ls-popover-content"><slot name="content"></slot></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['position'],
    data () {
      return {
        hover: false,
        pos: this.position,
        originalPos: this.position
      }
    },
    methods: {
      showPopover () {
        this.hover = true
      },
      hidePopover () {
        this.hover = false
      },
      checkResolution () {
        if (window.innerWidth <= 420) {
          this.pos = 'top'
        } else {
          this.pos = this.originalPos
        }
      }
    },
    computed: {
      className () {
        var klass = 'ls-popover-' + this.pos
        if (this.hover) klass += ' ls-active'

        return klass
      }
    },
    mounted () {
      window.addEventListener('resize', this.checkResolution)
      this.checkResolution()
    }
  }
</script>
<style lang="scss" scoped>
  .ls-popover {
    max-width: 210px;
    @media screen and (max-width: 420px) {
      min-width: auto;
    }
  }
  .popover-container {
    display: inline-block;
    .ls-popover-content {
      font-weight: normal;
    }
    .ls-popover-right {
      margin-left: 45px;
      margin-top: -14px;
    }
    .ls-popover-left {
      margin-top: -14px;
      margin-left: -2px;
    }
    .ls-popover-top {
      margin-top: -35px;
      margin-left: 23px;
    }
    .ls-popover-bottom {
      margin-top: 13px;
      margin-left: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// Popover.vue?3c42f1a2